enum ElementId {
  BackgroundOverlay = "BackgroundOverlay",
  BottomDrawerTitleRow = "BottomDrawerTitleRow",
  GoogleLoginButton = "GoogleLoginButton",
}

export default ElementId;
